module.exports = __webpack_public_path__ + "static/media/menu-outline.ce69d40b.svg";